import { z } from "zod";

/**
 * Telegram bot command
 *
 * Commands are shown in Telegram's command menu (the "/" button).
 * Each command has a response that gets sent when triggered.
 */
export const TelegramCommandSchema = z.object({
  /** Command name without slash (e.g., "start", "help", "menu") */
  command: z.string().min(1).max(32),
  /** Description shown in Telegram's command menu */
  description: z.string().min(1).max(256),
  /** Markdown response sent when command is triggered */
  response: z.string(),
  /** Whether command is visible in menu and active */
  enabled: z.boolean(),
  /** Built-in commands (/start, /reset) can't be deleted, only edited */
  isBuiltIn: z.boolean().optional()
});
export type TelegramCommand = z.infer<typeof TelegramCommandSchema>;
